import { useMutation } from "@apollo/client";
import { TrashIcon } from "@heroicons/react/24/outline";

import { Button, IconButton, Modal } from "../../../../../../../components/ui";
import { DELETE_FABRICATION } from "../../../../../../../graphql/mutation/Fabrication";

const Actions = props => {
  const { id } = props || {};
  const [deleteFabrication, { loading }] = useMutation(DELETE_FABRICATION, {
    refetchQueries: ["FetchFabricationsV2"],
  });

  const modalProps = {
    title: "Are you sure?",
    scale: "sm",
    description: `Would you like to delete this shipment cost?`,
    closeOnBackdrop: true,
    renderBody: ({ closeModal }) => {
      const handleDelete = () => {
        deleteFabrication({
          variables: {
            input: { id },
          },
        }).then(({ data }) => {
          const { deleteFabrication: { success } = {} } = data;
          if (success) {
            closeModal();
          }
        });
      };

      return (
        <div className="mt-4 flex">
          <Button
            className="mr-3"
            label={"Cancel"}
            action={"default"}
            onClick={() => {
              closeModal?.();
            }}
          />
          <Button
            label={loading ? "Deleting" : "Delete"}
            disabled={loading}
            onClick={handleDelete}
          />
        </div>
      );
    },
  };

  if (typeof id == "number") {
    return (
      <div className="user-list-actions flex text-right text-sm font-medium">
        {id && (
          <div className="grid">
            <Modal {...modalProps}>
              <IconButton variant="clean" title="Delete Cost">
                <TrashIcon className={`h-4 w-4 cursor-pointer text-gray-400`} />
              </IconButton>
            </Modal>
          </div>
        )}
      </div>
    );
  } else {
    return false;
  }
};

export default Actions;
